import { makeStyles } from '@mui/styles';
import ThumbnailSize from '../../constants/ThumbnailSize';

const useStyles = makeStyles(({ breakpoints }) => ({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '50%',

    width: ThumbnailSize.OverSm,
    height: ThumbnailSize.OverSm,
    [breakpoints.up('sm')]: {
      width: ThumbnailSize.OverMd,
      height: ThumbnailSize.OverMd,
    },
    [breakpoints.up('lg')]: {
      width: ThumbnailSize.OverXl,
      height: ThumbnailSize.OverXl,
    },
  },
  image: {
    height: '100%',
  },
}));

export interface HeroImageProps {
  src: string;
}

function HeroImage({ src }: HeroImageProps) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <img src={src} alt="" className={classes.image} />
    </div>
  );
}

export default HeroImage;
